module.exports = __webpack_public_path__ + "static/resume-bab3d259ddf1528ae0d50731a5b614e5.svg";